<template>
  <k-page class="page-starts">
    <div class="page-starts__controls">
      <el-tooltip content="Обновить данные" placement="top">
        <el-button @click="update" type="primary" icon="el-icon-refresh-left" circle size="mini" :loading="isMarathonsLoading"></el-button>
      </el-tooltip>

      <el-tooltip content="Добавить старт" placement="top">
        <el-button @click="handleAdd" type="success" icon="el-icon-plus" circle size="mini"></el-button>
      </el-tooltip>
    </div>

    <!-- BEGIN: Pagination -->
    <el-pagination
      v-if="numberOfPages > 1"
      @current-change="setCurrentPage"
      class="the-utils-emails__pagination"
      background
      layout="prev, pager, next"
      :total="marathonsCount"
      small
    >
    </el-pagination>
    <!-- END: Pagination -->

    <k-marathons-list
      :marathons="marathons"
      @edit="setMarathon"
      @delete="deleteMarathon"
    />

    <!-- BEGIN: Pagination -->
    <el-pagination
      v-if="numberOfPages > 1"
      @current-change="setCurrentPage"
      class="the-utils-emails__pagination"
      background
      layout="prev, pager, next"
      :total="marathonsCount"
      small
    >
    </el-pagination>
    <!-- END: Pagination -->

    <k-start-edit-form
      :dialogFormVisible="dialogFormVisible"
      :marathon="marathon"
      @cancel="handleCancel"
      @update="handleUpdateAfterAdd"
    />
  </k-page>
</template>

<script>
/**
 * Page: Страница фондов
 *
 * @version 1.0.0
 */


import { mapGetters, mapActions } from 'vuex';


// Components
import KPage from '@/components/KPage.vue';
import KStartEditForm from '@/components/KStartEditForm.vue';
import KMarathonsList from '@/components/KMarathonsList.vue';


const NUMBER_OF_MARATHONS_PER_PAGE = 10;

export default {
  name: 'page-starts',

  data() {
    return {
      activeMarathon: '',
      creatigNew: false,
      currentPage: 0,
    };
  },

  computed: {
    ...mapGetters({
      isMarathonsLoading: 'marathons/isMarathonsLoading',
      marathons: 'marathons/marathons',
      marathonsCount: 'marathons/marathonsCount',
      systemOrganizer: 'marathons/systemOrganizer',
    }),
    // Общее количество страниц
    numberOfPages() {
      return Math.ceil(this.marathonsCount / NUMBER_OF_MARATHONS_PER_PAGE);
    },

    marathon() {
      const marathon = this.marathons.find(item => item._id === this.activeMarathon);

      return this.creatigNew || !marathon
        ? {}
        : marathon;
    },

    dialogFormVisible() {
      return this.activeMarathon !== '' || this.creatigNew;
    },

  },

  async created() {
    await this.getSystemOrganizer();
    await this.getStartsOrganizers({
      limit: 1000,
      offset: 0,
    });
    await this.update();
  },

  methods: {
    async update() {
      await this.getMarathons({
        limit: NUMBER_OF_MARATHONS_PER_PAGE,
        offset: this.currentPage,
      });
    },

    setMarathon(id) {
      this.activeMarathon = id;
    },

    async setCurrentPage(numberOfPage) {
      this.currentPage = numberOfPage - 1;
      await this.update();
    },

    handleCancel() {
      this.creatigNew = false;
      this.activeMarathon = '';
    },

    async handleUpdateAfterAdd() {
      await this.update();
      this.creatigNew = false;
      this.activeMarathon = '';
    },

    async deleteMarathon(id) {
      await this.deleteMarathons([id]);
      await this.update();
    },

    // Добавление акции
    handleAdd() {
      this.creatigNew = true;
    },

    ...mapActions({
      deleteMarathons: 'marathons/deleteMarathons',
      getMarathons: 'marathons/getMarathons',
      getStartsOrganizers: 'starts/getStartsOrganizers',
      getSystemOrganizer: 'starts/getSystemOrganizer',
    }),
  },

  components: {
    KPage,
    KStartEditForm,
    KMarathonsList,
  },
};
</script>

<style lang="scss">
  .page-starts {
    display: flex;
    flex-direction: column;

    &__controls {
      margin-bottom: 24px;
    }
  }
</style>
